import { module } from 'angular';

import { STATE_CONFIG_PROVIDER, StateConfigProvider, INestedState} from '@spinnaker/core';
import { DinghyEvents } from './dinghyEvents';

export const DINGHY_EVENTS_STATE_PROVIDER = 'spinnaker.core.dinghy.events.state';
module(DINGHY_EVENTS_STATE_PROVIDER, [STATE_CONFIG_PROVIDER]).config([
  'stateConfigProvider',
  (stateConfigProvider: StateConfigProvider) => {
    const dinghyEventsState: INestedState = {
      name: 'dinghy-events',
      url: '/dinghy-events',
      views: {
        'main@': {
          component: DinghyEvents,
          $type: 'react',
        },
      },
      data: {
        pageTitleMain: {
          label: 'Dinghy Events',
        },
      },
      children: [],
    };
    stateConfigProvider.addToRootState(dinghyEventsState);
  },
]);
